import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { compose } from 'recompose';

import queryMetaHandler from '../../../utils/queryMetaHandler';
import omitProps from '../../../utils/omitProps';
import { querySelector } from '../../../utils';

export const GetUserMonthBonusMassUpdater = gql`
  query GetUserMonthBonusMassUpdaterQuery($bonusMonth: String! $districtId: Int!, $departmentId: Int!) {
    user_month_bonus_mass_updater(month: $bonusMonth, district_id: $districtId, department_id: $departmentId) {
      can_finalize
    }
  }
`;


const marshallData = ({ data, ownProps }) => {
  const [canFinalize] = querySelector(data, '$.user_month_bonus_mass_updater.can_finalize', []);

  return {
    ...ownProps,
    data,
    canFinalize,
  };
};


const queryGetAllUserMonthBonusData = graphql(GetUserMonthBonusMassUpdater, {
  props: marshallData,
});

export const queryGetUserMonthBonusMassUpdaterGQL = compose(
  queryGetAllUserMonthBonusData,
  queryMetaHandler,
  omitProps(['data']),
);
